import { render, staticRenderFns } from "./monitor_page.vue?vue&type=template&id=fda4dd38&scoped=true"
import script from "./monitor_page.vue?vue&type=script&lang=js"
export * from "./monitor_page.vue?vue&type=script&lang=js"
import style0 from "./monitor_page.vue?vue&type=style&index=0&id=fda4dd38&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fda4dd38",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fda4dd38')) {
      api.createRecord('fda4dd38', component.options)
    } else {
      api.reload('fda4dd38', component.options)
    }
    module.hot.accept("./monitor_page.vue?vue&type=template&id=fda4dd38&scoped=true", function () {
      api.rerender('fda4dd38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/iot/monitor/monitor_page.vue"
export default component.exports